import { BaseLoginInfo } from "./user.service";

export function checkStringAsEmptyToNull(value: string | undefined): string | null {
  const isEmpty = value === undefined || value === "";
  if (isEmpty) {
    return null;
  }
  return value;
}

export function isOnInstalledPWA(): boolean {
  try {
    return window.matchMedia("(display-mode: standalone)").matches;
  } catch (_) {
    return false;
  }
}

export function containsAuthScope(token: BaseLoginInfo, scope: string): boolean {
  try {
    const auths = token?.jwtPayload?.auths;
    return auths?.includes(scope);
  } catch (error) {
    return false;
  }
}

export function hasMFALoginToDo(token: BaseLoginInfo): boolean {
  try {
    const tokenParams = token?.jwtPayload?.params;
    if (!tokenParams) {
      false;
    }
    const mfaContext = !!tokenParams?.["_mfaContext"];
    if (!mfaContext) {
      return false;
    }
    return mfaContext;
  } catch (error) {
    throw new Error("errors.AUTH_TOKEN_MISSING");
  }
}